import { useMutation, useQueryClient } from "@tanstack/react-query";

import { instance } from "@/lib/axios/instance";
import { descriptionGroupQueryKeys } from "@/lib/contexts/DescriptionGroup/queryKeys";

interface SyncDescriptionGroupsResponse {
  data: string[];
  message: string;
}

export function useSyncDescriptionGroups() {
  const queryClient = useQueryClient();

  return useMutation<
    SyncDescriptionGroupsResponse,
    Error,
    { clientId: string }
  >({
    mutationFn: ({ clientId }) =>
      instance
        .post<SyncDescriptionGroupsResponse>(
          `/api/v2/Descriptions/Groups/Sync?clientId=${clientId}`
        )
        .then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: descriptionGroupQueryKeys.all,
      });
    },
  });
}
